import React, {FC, PropsWithChildren} from 'react';

import {Stringifier} from '../stringifier';
import {useFrameContext} from './frameContext';

/*
 * Component.
 */

export const FrameTitle: FC<PropsWithChildren<unknown>> = ({children}) => {
  const {updateTitle} = useFrameContext();
  return <Stringifier onTextChange={updateTitle}>{children}</Stringifier>;
};
